import React, { Suspense, lazy } from "react";
import "./styles/globals.css";
import "./styles/animations.css";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import Certifications from "./components/Certifications/Certifications";
import Honors from "./components/Honors/Honors";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import CustomCursor from "./components/CustomCursor/CustomCursor";

const App = () => {
  return (
    <div>
      <CustomCursor />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Certifications />
        <Honors />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;
